module.exports = __webpack_public_path__ + "static/img/b-3.45f568e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/b-3.png
// module id = zzvs
// module chunks = 0